import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { UserPlus, Copy, Send } from 'lucide-react';
import { toast } from 'sonner';

const SITE = 'https://falocomodono.com.br';

const LINKS = [
  {
    key: 'partner',
    icon: '🤝',
    title: 'Parceiro Relâmpago',
    desc: 'Empresa parceira se cadastra sozinha: ativação automática, 20% recorrente, subconta Asaas e kit no WhatsApp.',
    url: `${SITE}/parceiro/cadastro`,
    wa: `Quer ser Parceiro Oficial do Falo com o Dono? 🤝\n\n20% de comissão recorrente todo mês, painel próprio e ativação imediata. Cadastre-se em 1 minuto:\n\n${SITE}/parceiro/cadastro`,
  },
  {
    key: 'affiliate',
    icon: '⭐',
    title: 'Afiliado Relâmpago',
    desc: 'Afiliado se inscreve sozinho: aprovação na hora, senha + link pessoal + passo a passo no WhatsApp.',
    url: `${SITE}/afiliado/cadastro`,
    wa: `Quer ganhar comissão vendendo o Falo com o Dono? ⭐\n\nCadastro em 1 minuto, aprovação na hora e você já sai com seu link de vendas:\n\n${SITE}/afiliado/cadastro`,
  },
];

const AdminRecruitLinks = () => (
  <Card data-testid="recruit-links-card">
    <CardHeader>
      <CardTitle className="flex items-center gap-2 text-lg"><UserPlus className="w-5 h-5 text-[#C5A059]" /> Links de Recrutamento</CardTitle>
      <p className="text-sm text-slate-500">Alinhou com a pessoa? É só enviar o link — ela se cadastra sozinha e recebe o kit completo no WhatsApp.</p>
    </CardHeader>
    <CardContent className="space-y-3">
      {LINKS.map(l => (
        <div key={l.key} className="border border-slate-200 rounded-xl p-3.5 space-y-2" data-testid={`recruit-${l.key}`}>
          <p className="text-sm font-bold text-[#0A2647]">{l.icon} {l.title}</p>
          <p className="text-xs text-slate-500">{l.desc}</p>
          <p className="text-xs font-mono text-slate-700 bg-slate-50 border border-slate-100 rounded-lg px-3 py-2 break-all">{l.url}</p>
          <div className="flex gap-2">
            <Button size="sm" className="bg-[#C5A059] hover:bg-[#b08e4a] text-white gap-1.5 text-xs h-8 px-3" data-testid={`recruit-${l.key}-copy`}
              onClick={() => { navigator.clipboard.writeText(l.url); toast.success('Link copiado'); }}>
              <Copy className="w-3 h-3" /> Copiar
            </Button>
            <Button size="sm" variant="outline" className="gap-1.5 text-xs h-8 px-3 border-emerald-300 text-emerald-700 hover:bg-emerald-50" data-testid={`recruit-${l.key}-whatsapp`}
              onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(l.wa)}`, '_blank')}>
              <Send className="w-3 h-3" /> Enviar no WhatsApp
            </Button>
          </div>
        </div>
      ))}
    </CardContent>
  </Card>
);

export default AdminRecruitLinks;
